import BreadCrumb from "../components/BreadCrumb"
import { ExploreItem, ExploreItemType } from "./components/ExploreItem"
import { useExploreData } from "../useExploreData"



const ExploreDashboards = () => {
  const {
    publicDashboards,
  } = useExploreData()

  return <div className="" key="12312312">
    <div className="border-b-2 px-6 py-2 flex justify-between items-center">
      <BreadCrumb  >
        Explore
        <span className="mx-3">/</span>
        Browse Dashboards (2,000)
      </BreadCrumb>
      {/* <FilterGroup /> */}
    </div>
    <div className="px-16 py-8">
      {/* List of Items */}
      <div id="section-content" className=" flex justify-between flex-wrap">
        {
          publicDashboards.map((item, index) => {
            return <ExploreItem type={ExploreItemType.DASHBOARD} key={index}
              title={item?.displayName}
              author={item?.creator?.name}
              imgUrl={''}
              description={item?.description}
              item={item}
            />
          })
        }
      </div>
    </div>
  </div>
}

export default ExploreDashboards;